module.exports = __webpack_public_path__ + "static/media/rightAngleTriangle3.4644553e.svg";